export default {"src":"/_next/static/media/2D-side.8db96089.svg","height":30,"width":21};